module.exports = __webpack_public_path__ + "static/img/IMAS.70641c6b.png";